var React = require('react');

function PageArrowInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M9.5 1L1 9L9.5 17","key":0}),React.createElement("path",{"d":"M19.5 9H1.5","key":1})]);
}

PageArrowInline.defaultProps = {"width":"20","height":"18","viewBox":"0 0 20 18","fill":"none"};

module.exports = PageArrowInline;

PageArrowInline.default = PageArrowInline;
